import { createContext } from "react";

import type { ClientConfig } from "../../types/client-config";

/**
 * Client Configuration Context Value
 */
type ClientConfigContextValue = {
  clientConfig: ClientConfig | null;
  isLoading: boolean;
  updateConfig: (config: ClientConfig) => Promise<void>;
  clearConfig: () => Promise<void>;
  refreshConfig: () => Promise<void>;
};

/**
 * Client Configuration Context
 *
 * Centralized context for client configuration.
 * Single source of truth for all client config across the app.
 * Config is stored in IndexedDB and shared via this context.
 */
export const ClientConfigContext = createContext<
  ClientConfigContextValue | undefined
>(undefined);
